import { all, takeEvery, put, call } from 'redux-saga/effects';
import actions from './actions';
import authActions from '../../redux/auth/actions';
import Api from '../../helpers/api';
import { sendRequest } from '../../helpers/saga';
import { logger } from '../../helpers/logger';
import notifications from '../../redux/notifications/actions';
import { keyByProperty } from '../../helpers/core';
import { t } from '../../i18n';

const profileApi = new Api('profile');
const timezoneApi = new Api('profile/update_time_zone');

function* loadData() {
  try {
    const result = yield call(sendRequest, profileApi.load, {}, notifications.REQUEST_ERROR);

    if (result && result.data && result.data.success && result.data.success.data) {
      const { data } = result.data.success;

      yield put(actions.loadDataSuccess({ data }));
      yield put(authActions.updateProfileAvatar({ avatarUrl: data?.avatar_url }));
    }
  } catch (error) {
    logger.error(error);
  }
}

function* loadFormData() {
  try {
    const result = yield call(sendRequest, profileApi.loadFormData, {}, notifications.REQUEST_ERROR);

    if (result?.data?.success?.data) {
      const { data } = result.data.success;

      yield put(actions.loadFormData({ data }));
    }
  } catch (error) {
    logger.error(error);
  }
}

function* updateTimezone({ payload }) {
  try {
    const { time_zone } = payload;
    const result = yield call(
      sendRequest,
      timezoneApi.updateItem,
      { data: { time_zone } },
      notifications.REQUEST_ERROR,
    );

    if (result && result.data) {
      yield put(authActions.updateSelectedTimezone(time_zone));
      yield put(
        notifications.addNotification({
          headline: t('dash.common.notification.success_headline'),
          type: 'success',
          message: t('dash.common.notification.updated_successfully', { item: t('dash.profile.time_zone_title') }),
        }),
      );
    }
  } catch (error) {
    logger.error(error);
  }
}

function* updateProfile(data) {
  try {
    const { payload } = data;
    const { editForm, cb } = payload;

    const propsArray = Object.values(editForm);
    const admin = keyByProperty(propsArray, 'name', prop => prop.value);

    const { avatar_url, avatar, time_zone, ...otherProps } = admin;
    const saveProfileObject = { ...otherProps };

    if (!avatar && avatar_url) {
      saveProfileObject.avatar_url = avatar_url;
    } else if (avatar) {
      saveProfileObject.avatar = avatar;
    }

    saveProfileObject.time_zone = time_zone;
    saveProfileObject.country_id = saveProfileObject.country.id;
    saveProfileObject.state_id = saveProfileObject.state.id;

    const result = yield call(
      sendRequest,
      profileApi.updateItem,
      { data: { admin: saveProfileObject } },
      notifications.REQUEST_ERROR,
    );

    if (result && result.data) {
      yield put(actions.saveSuccess({ data: { admin } }));
      yield put(authActions.updateSelectedTimezone(time_zone));
      yield put(authActions.updateProfile({ profile: admin }));
      yield put(
        notifications.addNotification({
          headline: t('dash.common.notification.success_headline'),
          type: 'success',
          message: t('dash.common.notification.updated_successfully', { item: t('dash.profile.profile_title') }),
        }),
      );
      cb();
    } else {
      yield put(actions.saveError({ data: result }));
    }
  } catch (error) {
    logger.error(error);
  }
}

export default function* rootSaga() {
  yield all([
    takeEvery(actions.LOAD, loadFormData),
    takeEvery(actions.SAVE, updateProfile),
    takeEvery(actions.UPDATE_TIMEZONE, updateTimezone),
    takeEvery(actions.LOAD, loadData),
  ]);
}
